export default `
  fragment CommonV2DesignElement on BoothV2DesignElement {
    id
    positionX {
      ...Measurement
    }
    positionY {
      ...Measurement
    }
    width {
      ...Measurement
    }
    height {
      ...Measurement
    }
  }
`;
